import { render, staticRenderFns } from "./Committees.html?vue&type=template&id=4f849d15&external"
import script from "./Committees.ts?vue&type=script&lang=ts&external"
export * from "./Committees.ts?vue&type=script&lang=ts&external"
import style0 from "./Committees.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports